import { soundService } from '../../../../services/baseSoundService/soundService';

export const RouletteSoundsName = {
  bgMusic: 'bg-music',
  win: 'win',
  bet: 'bet',
  undoClear: 'undoClear',
  chip: 'chip',
  wheel: 'wheel',
};

export const RouletteSoundsPath = [
  {
    src: 'audio/roulette/background_music.mp3',
    name: RouletteSoundsName.bgMusic,
    autoplay: false,
    html5: true,
    loop: false,
    buffer: true,
    onplay: function () {
      this._sounds[0]._node.bufferTime = 0.5; // need it for safari
    },
    onend: function () {
      soundService.play(RouletteSoundsName.bgMusic);
    },
  },
  {
    src: 'audio/roulette/bet.mp3',
    name: RouletteSoundsName.bet,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/roulette/wheel_sound.mp3',
    name: RouletteSoundsName.wheel,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/roulette/Win_turbo.mp3',
    name: RouletteSoundsName.win,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/roulette/x2_undo_clear.mp3',
    name: RouletteSoundsName.undoClear,
    autoplay: false,
    html5: true,
  },
  {
    src: 'audio/roulette/chip.mp3',
    name: RouletteSoundsName.chip,
    autoplay: false,
    html5: true,
  },
];
